// @ts-check
import qs from "qs";

/**
 * Removes all key-value pairs from an object where the value is null or undefined.
 *
 * @param {object} inputObject
 * @returns A new object with all key-value pairs removed where the value is null or undefined.
 */
function filterNonNull(inputObject) {
  return Object.fromEntries(Object.entries(inputObject).filter(([k, v]) => v));
}

/**
 * Query stringifies an object.
 *
 * @param {object} inputObject
 * @returns {string}
 */
export function QueryStringfy(inputObject) {
  return qs.stringify(filterNonNull(inputObject), {
    skipNulls: true,
  });
}
